import React, { useState } from "react";
import MainLayout from "../layout/MainLayout";
import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";
import Drone3 from "../assets/drone3.jpg";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`New Travel Inquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\nMessage:\n${form.message}`
    );
    window.location.href = `mailto:muhaadsolutions@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <MainLayout>
      {/* Hero */}
      <section className="relative h-[60vh] rounded-3xl mx-4 sm:mx-10 mb-16 overflow-hidden shadow-xl">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${Drone3})` }}
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center text-center p-6 sm:p-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-white max-w-2xl"
          >
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 just-me-again-down-here-regular">
              Let’s Plan Your Ugandan Escape
            </h1>
            <p className="text-lg sm:text-xl">
              Get in touch with Muhaad’s travel specialists today.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 mb-24">
        {/* Contact Form */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white/30 dark:bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-lg border border-white/20 dark:border-white/10"
        >
          <h2 className="text-4xl font-bold mb-6 just-me-again-down-here-regular">
            Send Us a Message
          </h2>
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg bg-white/70 dark:bg-gray-800 border border-white/20 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="Your full name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg bg-white/70 dark:bg-gray-800 border border-white/20 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <textarea
                rows="5"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                className="w-full p-3 rounded-lg bg-white/70 dark:bg-gray-800 border border-white/20 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="Tell us about your travel plans..."
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium transition w-full sm:w-auto"
            >
              Send Message
            </button>
          </form>
        </motion.div>

        {/* Contact Details */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-6 text-gray-800 dark:text-gray-200"
        >
          <h2 className="text-4xl font-bold mb-4 just-me-again-down-here-regular">
            Get in Touch
          </h2>
          <div className="flex items-start gap-4">
            <MapPin className="text-teal-500 mt-1" />
            <p>
              Muhaad HQ <br />
              Kampala, Uganda
            </p>
          </div>
          <div className="flex items-start gap-4">
            <Phone className="text-teal-500 mt-1" />
            <p>+256 773 222402</p>
          </div>
          <div className="flex items-start gap-4">
            <Mail className="text-teal-500 mt-1" />
            <p>muhaadsolutions@gmail.com</p>
          </div>
          {/* <div className="pt-6">
            <a
              href="https://goo.gl/maps/..." // Update with actual Google Map link
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-teal-600 hover:underline"
            >
              View us on Google Maps →
            </a>
          </div> */}
        </motion.div>
      </section>
    </MainLayout>
  );
};
